import React from 'react';
import { Modal, Descriptions, Tag, Button } from 'antd';

export const getStatusColor = (status) => {
  const colors = {
    requested: 'blue',
    pending: 'orange',
    completed: 'green',
    cancelled: 'red',
    waiting: 'purple'
  };
  return colors[status] || 'default';
};

const BetDetailsModal = ({ visible, onClose, betDetails, onDelete }) => {
  return (
    <Modal
      title="Bet Details"
      open={visible}
      onCancel={onClose}
      footer={[
        // <Button key="delete" type="danger" onClick={() => onDelete(betDetails._id)}>
        //   Delete Bet
        // </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>
      ]}
      width={700}
    >
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Title">{betDetails?.title}</Descriptions.Item>
        <Descriptions.Item label="Description">{betDetails?.description}</Descriptions.Item>
        <Descriptions.Item label="Created By">{betDetails?.from_user_id}</Descriptions.Item>
        <Descriptions.Item label="Participant">{betDetails?.to_user_id}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={getStatusColor(betDetails?.status)}>
            {betDetails?.status?.toUpperCase()}
          </Tag>
        </Descriptions.Item>
        {betDetails?.winner_user_id && (
          <Descriptions.Item label="Winner">
            {betDetails.winner_user_id}
          </Descriptions.Item>
        )}
        {betDetails?.winner_status && (
          <Descriptions.Item label="Winner Response">
            <Tag color={betDetails.winner_status === 'agree' ? 'green' : 'red'}>
              {betDetails.winner_status.toUpperCase()}
            </Tag>
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Created At">
          {new Date(betDetails?.created_at).toLocaleString()}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default BetDetailsModal;
